<template>
  <div class="listing-form location-information margin-auto">
    <Card class="location-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-pin"/>
        <div><p style="color:#000;font-weight:bold">Location</p></div>
      </div>
      <div>
        <Form ref="LocationInformationForm" :model="value" :rules="formRules" label-position="top">
         <FormItem label="Headquarters office" prop="address">
            <Input v-model="value.address" class="k-input"/>
          </FormItem>
          <FormItem style="margin-bottom:25px;">
            <span slot="label">
              <!-- <span style="color:#ed4014;font-family:SimSun;margin-right:4px;line-height:1;">*</span> -->
              Lock pin location
              <Tooltip max-width="300" placement="top" content="Important field for SEARCH">[?]</Tooltip>
            </span>
            <div class="mapbox-geocoder-wrapper">
              <div id="mapbox-geocoder" class="fullwidth" style="height:32px"></div>
              <Icon @click="getCurrentLocation" type="md-locate" class="clickable"/>
            </div>
            <MglMap :accessToken="mapboxAccessToken" :mapStyle.sync="mapStyle" id="vue-mapbox-mglmap" @load="onMapLoaded" :zoom="15" :center="(value.longitude && value.latitude)? [value.longitude, value.latitude]:[-0.096131, 51.519763]">
              <MglNavigationControl position="bottom-right" />
              <!-- <MglMarker :coordinates="(value.longitude && value.latitude)? [value.longitude, value.latitude]:defaultCoordinates" color="red" /> -->
            </MglMap>
          </FormItem>
          <FormItem prop="other_location">
            <span slot="label">
              Other locations
              <Tooltip max-width="300" placement="top" content="You may include Google Map links with your addresses">[?]</Tooltip>
            </span>
            <TinyEditor v-model="value.other_location"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import '@mapbox/mapbox-gl-geocoder/lib/mapbox-gl-geocoder.css'
import TinyEditor from '@/components/ui/TinyEditor'
import { MglMap, MglNavigationControl } from 'vue-mapbox'
import axios from 'axios'
import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    TinyEditor,
    MglMap,
    MglNavigationControl
  },

  data () {
    // const validateLocation = (rule, value, callback) => {
    //   if (this.value.latitude && this.value.longitude) {
    //     callback()
    //   } else {
    //     callback(new Error('Please enter location'))
    //   }
    // }
    return {
      mapbox_access_token: process.env.VUE_APP_MAPBOX_API_KEY,
      formRules: {
        address: [
          { required: true, message: 'The address cannot be empty', trigger: 'blur' }
        ]
        // location: [
        //   { validator: validateLocation, trigger: 'blur' }
        // ]
      },
      mapboxAccessToken: process.env.VUE_APP_MAPBOX_API_KEY,
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      defaultCoordinates: [-0.096131, 51.519763],
      mapMarker: null
    }
  },

  methods: {
    onMapLoaded (event) {
      this.map = event.map

      var geocoder = new MapboxGeocoder({
        accessToken: this.mapboxAccessToken,
        types: 'country,region,place,postcode,locality,neighborhood, address, poi',
        countries: 'AL, AD, AM, AT, BY, BE, BA, BG, CH, CY, CZ, DE, DK, EE, ES, FO, FI, FR, GB, GE, GI, GR, HU, HR, IE, IS, IT, LT, LU, LV, MC, MK, MT, NO, NL, PL, PT, RO, RU, SE, SI, SK, SM, TR, UA, VA, RS, MD, ME, LI',
        mapboxgl: mapboxgl,
        language: 'en',
        placeholder: 'e.g. "London"'
      })

      document.getElementById('mapbox-geocoder').appendChild(geocoder.onAdd(this.map))
      if (this.value.location) document.querySelectorAll('.mapboxgl-ctrl-geocoder--input')[0].value = this.value.location
      const vm = this

      geocoder.on('result', function (e) {
        const results = JSON.stringify(e.result, null, 2)
        vm.value.location = JSON.parse(results).place_name
        vm.value.longitude = JSON.parse(results).center[0].toFixed(5).toString()
        vm.value.latitude = JSON.parse(results).center[1].toFixed(5).toString()
      })

      geocoder.on('clear', function () {
        vm.value.location = ''
        vm.value.longitude = null
        vm.value.latitude = null
        document.querySelectorAll('.mapboxgl-marker.mapboxgl-marker-anchor-center').forEach(el => el.remove())
      })

      this.map.on('click', async (event) => {
        const response = await axios.get(`${process.env.VUE_APP_MAPBOX_API_URL}${event.lngLat.lng},${event.lngLat.lat}.json?access_token=${this.mapboxAccessToken}`)
        this.value.location = response.data.features[0].place_name
        document.querySelectorAll('.mapboxgl-ctrl-geocoder--input')[0].value = response.data.features[0].place_name
        document.querySelectorAll('.mapboxgl-marker.mapboxgl-marker-anchor-center').forEach(el => el.remove())
        const marker = new mapboxgl.Marker().setLngLat(response.data.features[0].center).addTo(this.map)
        marker.on('dragend', (e) => {
          this.center = Object.values(e.target.getLngLat())
        })
      })
    },

    async getCurrentLocation () {
      try {
        await navigator.geolocation.getCurrentPosition(
          async position => {
            this.value.latitude = position.coords.latitude.toFixed(5).toString()
            this.value.longitude = position.coords.longitude.toFixed(5).toString()
            const response = await axios.get(`${process.env.VUE_APP_MAPBOX_API_URL}${this.value.longitude},${this.value.latitude}.json?access_token=${this.mapboxAccessToken}`)
            this.value.location = response.data.features[0].place_name
            document.querySelectorAll('.mapboxgl-ctrl-geocoder--input')[0].value = response.data.features[0].place_name
            document.querySelectorAll('.mapboxgl-marker.mapboxgl-marker-anchor-center').forEach(el => el.remove())
            const marker = new mapboxgl.Marker().setLngLat(response.data.features[0].center).addTo(this.map)
            marker.on('dragend', (e) => {
              this.center = Object.values(e.target.getLngLat())
            })
          },
          error => {
            console.log(error.message)
          }
        )
      } catch (err) {
        console.log(err)
      }
    },

    handleSubmit () {
      this.$refs.LocationInformationForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.location-information {
  max-width:700px;
  .location-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.location-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
